export default __webpack_public_path__ + "static/media/12.5a7e5f44.jpg";